<template>
  <v-app class="white">
    <v-dialog v-model="serviceUnavailable" width="500" persistent>
      <v-card>
        <v-card-title>
          Service unavailable
        </v-card-title>
        <v-card-text>
          This service is not available in your region.
        </v-card-text>
      </v-card>
    </v-dialog>
    <router-view v-if="!checkingStatus && !serviceUnavailable"></router-view>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import api from './api/api';

export default {
  data() {
    return {
      checkingStatus: true,
      serviceUnavailable: false,
    };
  },
  mounted() {
    this.checkServiceStatus();
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
  },
  methods: {
    checkServiceStatus() {
      api.getState()
        .then(() => {
          this.checkingStatus = false;
          this.serviceUnavailable = false;
        })
        .catch((error) => {
          // 403 = service unavailable
          if (error.response.status === 403) {
            this.serviceUnavailable = true;
          }
          this.checkingStatus = false;
        });
    },
  },
};
</script>

<style>
.hide-overflow {
  overflow: hidden;
}
.auto-overflow {
  overflow-y: auto;
}
.h-100 {
  height: 100%;
}
.f-100 {
  flex: 100%;
}
.b-l {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}
.b-r {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.b-t {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.b-b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.debug {
  border: 1px inset red;
}
/* CookieBot styling */
#CybotCookiebotDialog {
  border: 18px solid #fff !important;
  border-radius: 0px !important;
}
@media screen and (max-width: 960px) {
  .hide-overflow {
    overflow: inherit;
  }
}
</style>

<style scoped>
@font-face {
  font-family: "finlandica-web";
  src: url("/finlandica-boldWeb.woff2") format("woff2"),
    url("/finlandica-boldWeb.woff") format("woff"),
    url("/finlandica-boldWeb.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "finlandica-web";
  src: url("/finlandica-bolditalicWeb.woff2") format("woff2"),
    url("/finlandica-bolditalicWeb.woff") format("woff"),
    url("/finlandica-bolditalicWeb.ttf") format("truetype");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "finlandica-web";
  src: url("/finlandica-italicWeb.woff2") format("woff2"),
    url("/finlandica-italicWeb.woff") format("woff"),
    url("/finlandica-italicWeb.ttf") format("truetype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "finlandica-web";
  src: url("/finlandica-regularWeb.woff2") format("woff2"),
    url("/finlandica-regularWeb.woff") format("woff"),
    url("/finlandica-regularWeb.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.v-application {
  font-family: "finlandica-web", roboto, sans-serif !important;
}
</style>
